import { Question } from "../../../domain/entities/question/Question";
import { FeedbackRepository } from "../../../domain/repositories/FeedbackRepository";
import { createHttpClients } from "../shared/createHttpClients";
import { mapQuestionsDTOtoQuestions } from "./responseMapper";

class FeedbackRepositoryImpl implements FeedbackRepository {
  private static instance: FeedbackRepositoryImpl;

  private constructor() {}

  public static getInstance(): FeedbackRepositoryImpl {
    if (!FeedbackRepositoryImpl.instance) {
      FeedbackRepositoryImpl.instance = new FeedbackRepositoryImpl();
    }

    return FeedbackRepositoryImpl.instance;
  }

  public async getOrderFeedback(auth: string, variantId: string, apiUrl: () => string): Promise<Question[]> {
    try {
      const { httpGet } = createHttpClients(auth, apiUrl);
      const response = await httpGet<{ questions: Parameters<typeof mapQuestionsDTOtoQuestions>[0] }>({
        endpoint: `/feedback/v1/questions/${variantId}`,
      });
      return mapQuestionsDTOtoQuestions(response.questions);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export { FeedbackRepositoryImpl };
